import { ReactNode } from 'react';

import { useUserExperience } from '~/features/user/hooks/use-user-experience';

export type UserExperienceCardSwitcherProps = {
  freeCardSlot?: ReactNode;
  priceCardSlot: ReactNode;
  startLearningCardSlot: ReactNode;
};

export function UserExperienceCardSwitcher({
  freeCardSlot = null,
  priceCardSlot,
  startLearningCardSlot,
}: UserExperienceCardSwitcherProps) {
  const { userExperience, userExperienceIsFetched } = useUserExperience();

  if (freeCardSlot) {
    return <>{freeCardSlot}</>;
  }

  return (
    <>{userExperienceIsFetched && userExperience?.hasActiveSubscription ? startLearningCardSlot : priceCardSlot}</>
  );
}
